import { Routes as R, Route } from "react-router-dom";

import Main from "../pages/Main";
import Lists from "../pages/Lists";
import MovieList from "../pages/MovieList";
import Posts from "../pages/Posts";
import MoviePost from "../pages/MoviePost";
import Reviews from "../pages/Reviews";
import ReviewPage from "../pages/Review";

const Routes = () => {
  return (
    <R>
      <Route path="/" element={<Main />} />
      <Route path="/reviews/:reviewId" element={<ReviewPage />} />
      <Route path="/lists/" element={<Lists />} />
      <Route path="/posts/" element={<Posts />} />
      <Route path="/posts/:postId" element={<MoviePost />} />
      <Route path="/lists/:listId" element={<MovieList />} />
      <Route path="/reviews" element={<Reviews />} />
    </R>
  );
};

export default Routes;
